(function(scope){
  'use strict';
  const EPS=1e-7;
  const idHandles=['cycolinks-custom-10mm-personalised-id-bracelet','cycolinks-custom-10mm-black-personalised-id-bracelet','cycolinks-personalised-gold-mens-bike-c','cycolinks-custom-10mm-personalised-bracelet','cycolinks-10mm-black-crystal-personalised-id-bike-chain-bracelet','cycolinks-custom-10mm-rose-gold-crystal-personalised-id-bracelet'];
  const silverIds=['7777064255730','7944609104114','7931271086322'];
  function lengthCm(value){
    const text=String(value||'').trim().toLowerCase().replace(',','.');
    const m=text.match(/^(\d+(?:\.\d+)?)\s*(cm|mm|inches|inch|in)(?:\s+length)?$/);
    if(m)return Number(m[1])*(m[2]==='mm'?.1:/^in/.test(m[2])?2.54:1);
    return /^\d+(?:\.\d+)?$/.test(text)?Number(text):null;
  }
  function tagsOf(p){return Array.isArray(p.tags)?p.tags:String(p.tags||'').split(',').map(x=>x.trim());}
  function family(p){
    if(silverIds.includes(String(p.id||'').split('/').pop()))return 'silver';
    if(p.handle==='cycolinks-split-link-bracelet')return 'split';
    if(p.handle==='leather-bike-chain-bracelet')return 'leather';
    if(/adjustable/i.test(p.title||'')||p.handle==='cycolinks-road-bike-pendant-rope-bracelet')return 'adjustable';
    if(idHandles.includes(p.handle))return 'steel';
    if(tagsOf(p).some(t=>['7mm','10mm','16mm'].includes(t)))return 'steel';
    return 'other';
  }
  function optionNames(p){return (p.options||[]).map(o=>typeof o==='string'?o:o.name);}
  function lengthIndex(p){
    const names=optionNames(p);let i=names.findIndex(n=>/length/i.test(n));
    if(i<0)i=names.findIndex((n,j)=>/^size$/i.test(n)&&(p.variants||[]).some(v=>{const cm=lengthCm((v.options||[])[j]);return cm>=10&&cm<=35;}));return i;
  }
  function compatibleClasp(p,selection,data){
    if(family(p)!=='steel'||(data.excludedClasps||[]).includes(p.handle))return null;
    const tags=tagsOf(p),tag=tags.map(t=>t.match(/^(7mm|10mm|16mm) Extension Clasp: (Silver|Black|Gold)$/)).find(Boolean);
    let id=tag?data.claspIds?.[tag[1]+'|'+tag[2]]:data.claspByHandle?.[p.handle];
    return id?{id:String(id),extraCm:1.5,available:data.claspAvailability?.[String(id)]!==false}:null;
  }
  function candidates(p,selection){
    const i=lengthIndex(p);if(i<0)return [];
    return (p.variants||[]).filter(v=>(v.options||[]).every((value,j)=>j===i||!selection||selection[j]===undefined||selection[j]===value)).map(v=>({id:String(v.id),cm:lengthCm((v.options||[])[i]),available:Boolean(v.available),options:v.options||[]})).filter(v=>v.cm>=10&&v.cm<=35).sort((a,b)=>a.cm-b.cm);
  }
  function unique(a){return a.filter((v,i)=>a.findIndex(x=>Math.abs(v.cm-x.cm)<EPS)===i);}
  function fitLabel(room,min,max){return room<min-EPS?'snug':room>2.5+EPS?'very_roomy':room>max+EPS?'roomy':'standard';}
  function recommend(p,wristCm,fit,selection,data){
    data=data||{};selection=selection||[];const profile=['steel','leather','silver','split'].includes(data.profileOverride)?data.profileOverride:family(p),clasp=compatibleClasp(p,selection,data);
    const base={profile,candidates:[],clasp};
    if(!Number.isFinite(wristCm)||wristCm<10||wristCm>35)return {...base,status:'invalid'};
    if(profile==='adjustable'){
      const range=data.adjustable?.[p.handle];
      if(!range)return {...base,status:'adjustable_unknown'};
      if(range.kind==='total')return {...base,status:'adjustable_total',range};
      const minRoom=range.minRoom||.5,maxRoom=range.maxRoom||1.5;
      const within=Math.max(range.min,wristCm+minRoom)<=Math.min(range.max,wristCm+maxRoom)+EPS;
      return {...base,status:'adjustable_range',range,rangeFit:within?'within':wristCm>=range.max-EPS?'too_large':wristCm<range.min-(range.maxRoom||1.5)-EPS?'too_small':'near_limit'};
    }
    if(profile==='other'||lengthIndex(p)<0)return {...base,status:'unsupported'};
    const all=unique(candidates(p,selection)),available=all.filter(v=>v.available);
    if(!all.length)return {...base,status:'unsupported'};
    if(!available.length)return {...base,status:'unavailable'};
    const withRoom=v=>({...v,room:v.cm-wristCm});
    if(profile==='split'){
      const inChart=wristCm>=16-EPS&&wristCm<=22+EPS;
      const wanted=wristCm<=18+EPS?[19]:wristCm<=18.25+EPS?[19,21]:wristCm<=20+EPS?[21]:wristCm<=20.25+EPS?[21,23]:[23];
      const matches=available.filter(v=>wanted.includes(v.cm)&&v.cm>wristCm+EPS).map(v=>({...withRoom(v),fit:inChart?'chart':'outside_chart'}));
      if(matches.length)return {...base,status:!inChart?'caution':matches.length>1?'choices':'recommended',candidates:matches,chart:inChart};
      const nearby=available.filter(v=>v.cm>wristCm+EPS).sort((a,b)=>Math.abs(a.cm-(wristCm+1))-Math.abs(b.cm-(wristCm+1))).slice(0,2).map(v=>({...withRoom(v),fit:'outside_chart'}));
      return {...base,status:nearby.length?'caution':'no_fit',candidates:nearby,missing:wanted,nearestSoldOut:nearby.length>0};
    }
    const min=profile==='silver'?1:.5,max=1.5,target=wristCm+(profile==='silver'?1.25:({close:.5,regular:1,relaxed:1.5}[fit]||1));
    function rank(a,b){const diff=Math.abs(a.cm-target)-Math.abs(b.cm-target);return Math.abs(diff)<EPS?b.cm-a.cm:diff;}
    const positive=available.filter(v=>v.cm>wristCm+EPS).sort(rank);
    if(positive.length){
      const primary=positive[0],other=positive.slice(1).find(v=>v.cm-wristCm<=2.5+EPS);
      const options=[primary,...(other&&primary.cm-wristCm<=2.5+EPS?[other]:[])].map((v,i)=>({...withRoom(v),fit:fitLabel(v.cm-wristCm,min,max),preferred:i===0}));
      const closest=all.filter(v=>v.cm>wristCm+EPS).sort(rank)[0];
      return {...base,status:options[0].fit==='standard'?'recommended':'caution',candidates:options,target,nearestSoldOut:Boolean(closest&&!closest.available),usualRoom:{min,max}};
    }
    if(clasp){
      const extended=available.map(v=>({...v,baseCm:v.cm,cm:v.cm+clasp.extraCm})).filter(v=>v.cm>wristCm+EPS).sort(rank);
      if(extended.length){if(!clasp.available)return {...base,status:'extension_unavailable'};const v=extended[0];return {...base,status:'extension_required',candidates:[{...withRoom(v),requiresExtension:true,fit:fitLabel(v.cm-wristCm,min,max),preferred:true}],target};}
    }
    return {...base,status:'no_fit'};
  }
  const api={lengthCm,family,optionNames,lengthIndex,compatibleClasp,candidates,recommend};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;else scope.CycoGuideSizing=api;
})(typeof window==='undefined'?globalThis:window);
